// extracted by mini-css-extract-plugin
module.exports = {"rentalTitle":"kG","boxArtWrapper":"kH","rentalArtwork":"kI","rentalName":"kJ"};